module.exports = __webpack_public_path__ + "static/media/dieu-kien-tien-nghi.24763401.svg";